export default "<div #baAmChart class=\"ba-am-chart {{baAmChartClass || ''}}\"></div>\r\n"